export enum StressCategory {
  NORMAL = "NORMAL",
  MILD = "MILD",
  MODERATE = "MODERATE",
  SEVERE = "SEVERE",
}

export const STRESS_CATEGORY_LABEL: Record<StressCategory, string> = {
  [StressCategory.NORMAL]: "Dalam Batas Wajar",
  [StressCategory.MILD]: "Perlu Perhatian",
  [StressCategory.MODERATE]: "Perlu Penanganan",
  [StressCategory.SEVERE]: "Disarankan Mencari Bantuan Profesional atau Psikolog",
}

export interface IQuestionnaireSubmissionDto {
  user_id: string
  fullname: string
  age: number
  phone_number: string
  company_id: string
  company_code: string
  company_name: string
  note?: string
  item_1: number
  item_2: number
  item_3: number
  item_4: number
  item_5: number
  item_6: number
  item_7: number
  item_8: number
  item_9: number
  item_10: number
  item_11: number
  item_12: number
  item_13: number
  item_14: number
}

export interface IQuestionnaireSubmission extends IQuestionnaireSubmissionDto {
  id: string
  total_score: number
  category: StressCategory
  needs_followup: boolean
  submitted_at: string
  updated_at: string
}
